import { ReactElement, useMemo } from 'react';
import { Tabs, TabsProps } from '@mui/material';
import { useLocation, useResolvedPath, useSearchParams } from 'react-router-dom';

import { PoolTab, PoolTabProps } from './pool-tab';

const useCurrentRouteTab = (tabs: Record<string, string>, defaultTab: string): string => {
    const location = useLocation();
    const currentRoute = useResolvedPath(location.pathname);

    const result = useMemo((): string => {
        let tabRoute: string = defaultTab;
        for (const route of Object.values(tabs)) {
            if (currentRoute.pathname.includes(route)) {
                tabRoute = route;
                break;
            }
        }

        return tabRoute;
    }, [defaultTab, currentRoute, tabs]);

    return result;
};

export interface RouteTabsProps extends TabsProps {
    tabs: Record<string, string>;
}

export const RouteTabs = (props: RouteTabsProps): ReactElement => {
    const { tabs, value: _value, ...baseProps } = props;
    const currentTab = useCurrentRouteTab(tabs, Object.values(tabs)[0]);

    return (
        <Tabs
            indicatorColor="primary"
            value={currentTab}
            sx={{ pl: theme => theme.general.pageContentSpacing }}
            {...baseProps}
        >
            {props.children}
        </Tabs>
    );
};

export interface RouteTabProps extends PoolTabProps {
    searchParams?: URLSearchParams;
}

export const RouteTab = (props: RouteTabProps): ReactElement => {
    const [searchParams] = useSearchParams();

    return (
        <PoolTab
            replace={true}
            {...props}
            linkTo={{ pathname: props.value, search: props.searchParams?.toString() ?? searchParams?.toString() }}
        />
    );
};
